import _ from 'lodash';

export function isSignupComplete(siteContext) {
    return _.get(siteContext, 'user_signup_finished') === true;
}
